<template>
    <div>
        <ValidationObserver ref="observer" >
            <v-row align="start">
                <v-col>
                    <div class="primary1--text font-weight-bold title">
                        {{texto}}
                    </div>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="font-secundaria campo-cadu" style="color: rgb(96, 101, 108);">
                        COLABORADORES
                    </div>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <div class="font-secundaria campo-cadu" style="color: rgb(96, 101, 108);">
                        PCD
                    </div>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <div class="font-secundaria campo-cadu" style="color: rgb(96, 101, 108);">
                        TOTAL
                    </div>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        DIRETORES
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :disabled="disabled"
                            onlyNumber
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            v-model="colaboradorDiretor"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :disabled="disabled"
                            onlyNumber
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            v-model="pcdDiretor"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu colorBgField="#888" colorInput="#000000" textAlign="end" disabled :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber :value="totalDiretor"/>
                </v-col>
            </v-row>
            <v-row align="start">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        GESTORES
                        <tooltip-help width="400" text="Colaboradores que fazem a gestão de equipe tanto na esfera administrativa quanto no assistencial. Exemplos: superintendentes, gerentes, coordenadores, supervisores e líderes. Informar a quantidade conforme dados enviados ao CAGED."/>
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="colaboradorGestor"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="pcdGestor"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalGestor"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        COLABORADORES
                        <tooltip-help width="400" text="Informar a quantidade conforme dados enviados ao CAGED."/>
                    </div>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2'" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="colaborador"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="pcdColaborador"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalColaborador"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        ESTAGIÁRIOS
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="colaboradorEstagiario"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="pcdEstagiario"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalEstagiario"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        JOVENS APRENDIZES
                        <tooltip-help width="400" text="Informar a quantidade conforme dados enviados ao CAGED."/>
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="colaboradorAprendiz"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="pcdAprendiz"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalAprendiz"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        TEMPORÁRIOS
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="colaboradorTemporario"
                            textAlign="end"
                        />
                    </validation-provider>
                    </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <validation-provider rules="required|max:7" mode="eager" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                            onlyNumber
                            :disabled="disabled"
                            v-model="pcdTemporario"
                            textAlign="end"
                        />
                    </validation-provider>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalTemporario"/>
                </v-col>
            </v-row>
            <v-row align="center" class="pt-6">
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3" >
                    <div class="primary1--text">
                        TOTAL
                    </div>
                </v-col>
                <v-col class="pa-2" cols="12" sm="3" md="3" lg="3">
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalColaboradorGeral"/>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3" >
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalPcd"/>
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-2 '" cols="12" sm="3" md="3" lg="3">
                    <input-cadu textAlign="end" colorBgField="#888" colorInput="#000000" rules="required" :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###', '##.###.###', '###.###.###', '#.###.###.##']" onlyNumber disabled :value="totalGeral"/>
                </v-col>
            </v-row>
        </ValidationObserver>
    </div>
</template>

<script>
import { get } from 'lodash'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    texto: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colaboradorDiretor: 0,
      colaboradorGestor: 0,
      colaborador: 0,
      colaboradorEstagiario: 0,
      colaboradorAprendiz: 0,
      colaboradorTemporario: 0,
      pcdDiretor: 0,
      pcdGestor: 0,
      pcdColaborador: 0,
      pcdEstagiario: 0,
      pcdAprendiz: 0,
      pcdTemporario: 0,
      tooltip: false
    }
  },
  methods: {
    clean () {
      this.colaboradorDiretor = 0
      this.colaboradorGestor = 0
      this.colaborador = 0
      this.colaboradorEstagiario = 0
      this.colaboradorAprendiz = 0
      this.colaboradorTemporario = 0
      this.pcdDiretor = 0
      this.pcdGestor = 0
      this.pcdColaborador = 0
      this.pcdEstagiario = 0
      this.pcdAprendiz = 0
      this.pcdTemporario = 0
    },
    async modelValues (data) {
      this.colaboradorDiretor = get(data[0], 'quantidadeItens', 0)
      this.pcdDiretor = get(data[1], 'quantidadeItens', 0)
      this.colaboradorGestor = get(data[2], 'quantidadeItens', 0)
      this.pcdGestor = get(data[3], 'quantidadeItens', 0)
      this.colaborador = get(data[4], 'quantidadeItens', 0)
      this.pcdColaborador = get(data[5], 'quantidadeItens', 0)
      this.colaboradorEstagiario = get(data[6], 'quantidadeItens', 0)
      this.pcdEstagiario = get(data[7], 'quantidadeItens', 0)
      this.colaboradorAprendiz = get(data[8], 'quantidadeItens', 0)
      this.pcdAprendiz = get(data[9], 'quantidadeItens', 0)
      this.colaboradorTemporario = get(data[10], 'quantidadeItens', 0)
      this.pcdTemporario = get(data[11], 'quantidadeItens', 0)
    },
    returnValues () {
      return {
        diretor: this.colaboradorDiretor,
        gestor: this.colaboradorGestor,
        colaborador: this.colaborador,
        estagiario: this.colaboradorEstagiario,
        aprendiz: this.colaboradorAprendiz,
        temporario: this.colaboradorTemporario,
        pcdDiretor: this.pcdDiretor,
        pcdGestor: this.pcdGestor,
        pcdColaborador: this.pcdColaborador,
        pcdEstagiario: this.pcdEstagiario,
        pcdAprendiz: this.pcdAprendiz,
        pcdTemporario: this.pcdTemporario
      }
    }
  },
  computed: {
    totalDiretor () {
      let a = (this.pcdDiretor * 1) || 0
      let b = (this.colaboradorDiretor * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalGestor () {
      let a = (this.pcdGestor * 1) || 0
      let b = (this.colaboradorGestor * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalColaborador () {
      let a = (this.pcdColaborador * 1) || 0
      let b = (this.colaborador * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalEstagiario () {
      let a = (this.pcdEstagiario * 1) || 0
      let b = (this.colaboradorEstagiario * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalAprendiz () {
      let a = (this.pcdAprendiz * 1) || 0
      let b = (this.colaboradorAprendiz * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalTemporario () {
      let a = (this.pcdTemporario * 1) || 0
      let b = (this.colaboradorTemporario * 1) || 0
      let result = ((a + b) * 1) || 0
      return result
    },
    totalColaboradorGeral () {
      let a = (this.colaboradorDiretor * 1) || 0
      let b = (this.colaboradorGestor * 1) || 0
      let c = (this.colaborador * 1) || 0
      let d = (this.colaboradorEstagiario * 1) || 0
      let e = (this.colaboradorAprendiz * 1) || 0
      let f = (this.colaboradorTemporario * 1) || 0
      let total = ((a + b + c + d + e + f) * 1) || 0
      this.$emit('totalCola', total)
      return total
    },
    totalPcd () {
      let a = (this.pcdDiretor * 1) || 0
      let b = (this.pcdGestor * 1) || 0
      let c = (this.pcdColaborador * 1) || 0
      let d = (this.pcdEstagiario * 1) || 0
      let e = (this.pcdAprendiz * 1) || 0
      let f = (this.pcdTemporario * 1) || 0
      let total = ((a + b + c + d + e + f) * 1) || 0
      this.$emit('totalPcd', total)
      return total
    },
    totalGeral () {
      let a = (this.totalPcd * 1) || 0
      let b = (this.totalColaboradorGeral * 1) || 0
      let total = ((a + b) * 1) || 0
      this.$emit('totalGeral', total)
      return total
    }
  }
}
</script>

<style lang="sass" scoped>
.tooltip-help
    font-size: 15px
    border: 1px solid
    border-radius: 102px
    width: 19px
    display: inline-block
    height: 19px
    &:after
        content: '!'
        position: relative
        left: 5px
        bottom: 3px
</style>
